/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReleaseFlagsWithDefaults {
    getFixupPrototypeFunction() { return ReleaseFlagsWithDefaults.fixupPrototype; }

    static newInstance(model: Partial<ReleaseFlagsWithDefaults>): ReleaseFlagsWithDefaults {
        let obj = Object.assign(new ReleaseFlagsWithDefaults(), model);
        ReleaseFlagsWithDefaults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReleaseFlagsWithDefaults>): ReleaseFlagsWithDefaults {
        if (!model) return null;
        return ReleaseFlagsWithDefaults.newInstance(<ReleaseFlagsWithDefaults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReleaseFlagsWithDefaults) {
        if (!obj) return;

        models.ReleaseFlagsWithDefaults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReleaseFlagsWithDefaults): boolean {
        Object.setPrototypeOf(obj, ReleaseFlagsWithDefaults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Flag's default value
     */
    release_2504: boolean = false;

    /**
     * Flag's default value
     */
    release_2601: boolean = true;

    /**
     * Flag's default value
     */
    release_2602: boolean = true;

    /**
     * Flag's default value
     */
    release_2603: boolean = true;

    /**
     * Flag's default value
     */
    release_2604: boolean = true;

    /**
     * Flag's default value
     */
    release_2605: boolean = true;

    /**
     * Flag's default value
     */
    release_2606: boolean = true;

}
